export default __webpack_public_path__ + "static/media/4 DESKTOP COMPUTER.20d2cfa3.png";